// @flow
import * as React from 'react'

import './Alert.scss'

const CLASS_NAME = 'Alert'

type AlertType = 'neutral' | 'info' | 'success' | 'warning' | 'error'

type Props = {
  type: AlertType,
  large: boolean,
  onClick?: () => void,
  children: React.Node,
}

export default class Alert extends React.Component<Props> {
  static defaultProps = {
    large: false,
  }

  render = () => {
    return (
      <div className={this.className} onClick={this.props.onClick}>
        {this.props.children}
      </div>
    )
  }

  get className(): string {
    return [
      CLASS_NAME,
      this.props.onClick ? `${CLASS_NAME}--clickable` : null,
      this.props.large ? `${CLASS_NAME}--large` : null,
      this.typeClassNameModifier,
    ].join(' ')
  }

  get typeClassNameModifier(): string {
    switch (this.props.type) {
      case 'neutral':
        return `${CLASS_NAME}--neutral`

      case 'info':
        return `${CLASS_NAME}--info`

      case 'success':
        return `${CLASS_NAME}--success`

      case 'warning':
        return `${CLASS_NAME}--warning`

      case 'error':
        return `${CLASS_NAME}--error`

      default:
        return ''
    }
  }
}
